import registry from '../registry';

// Registry contains the base global styles used for styled-components
// Import Tailwind globals after the base global styles.
// This will allow Tailwind styles to override the base global
// TODO: Tailwind has global styles that affect other areas of the app,
// outside the areas using tailwind classnames. We comment this out until
// have a solution to scope the tailwind styles (may need to reset global tailwind styles).
// import '../src/styles/tailwindGlobals.css';

export default registry.createApp();
